import React from "react";
import { useOffline } from "./OfflineProvider";

export default function OfflineBanner() {
  const { isOnline, actions } = useOffline();
  if (isOnline) return null;
  return (
    <div className="offline-banner" role="status">
      <span>
        Sie sind offline. Gespeicherte Dokumente sind verfügbar; KI-Chat und Upload sind nur online verfügbar.
      </span>
      <button type="button" className="offline-btn offline-btn--ghost" onClick={() => actions.retryConnection()}>
        Erneut verbinden
      </button>
    </div>
  );
}
